import React from 'react';
import styled, { css } from 'react-emotion';
import { Link } from 'react-router-dom';
import t from '@jetshop/intl';
const StyledBreadcrumbs = styled('ul') `
  a,
  li {
    color: #777;
    font-size: 0.75rem;
  }

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  list-style: none;
  margin-bottom: 2rem;
  ${({ hideLast }) => !hideLast
    ? css `
          & li:last-child:after {
            display: none;
          }
        `
    : ''};
`;
const Breadcrumb = styled('li') `
  white-space: nowrap;
  &:after {
    display: inline-block;
    content: '/';
    padding: 0 0.33em;
  }
`;
export default class Breadcrumbs extends React.PureComponent {
    render() {
        const { breadcrumbText, parents, hideLast, className } = this.props;
        if (breadcrumbText) {
            let mappedParents = [];
            if (parents && parents.length > 0) {
                mappedParents = parents.reduceRight((acc, parent) => {
                    return [
                        ...acc,
                        {
                            text: parent.object.breadcrumbText,
                            path: parent.path
                        }
                    ];
                }, []);
            }
            const crumbs = [
                { text: t('Home'), path: '/' },
                ...mappedParents,
                { text: breadcrumbText, path: null }
            ];
            return (React.createElement(StyledBreadcrumbs, { hideLast: hideLast, className: className }, crumbs.map((crumb, index) => (React.createElement(Breadcrumb, { key: index }, !crumb.path ? (crumb.text) : (React.createElement(Link, { to: { pathname: crumb.path, state: { type: 'Category' } } }, crumb.text)))))));
        }
        else {
            return null;
        }
    }
}
//# sourceMappingURL=Breadcrumbs.js.map